import {
	ButtonGroup,
	FormControl,
	FormLabel,
	Heading,
	Icon,
	Input,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Switch,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { IconRefreshAlert } from '@tabler/icons';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import MoneyField from 'components/fields/MoneyField';
import { useEditAverageTicket } from 'pages/admin/demand/averageTicket/hooks/useEditAverageTicket';
import { useGetTicketMedioById } from 'pages/admin/demand/averageTicket/hooks/useGetTicketMedioById';
import { averageTicketMessages } from 'pages/admin/demand/averageTicket/variables/averageTicketMessages';
import React, { useEffect, useState } from 'react';
import { useForm } from 'services/hooks/useForm';
import { currencyToNumber } from 'utils/functions/currencyToNumber';

export function EditModal(props) {
	const {
		title,
		text,
		firstLabel,
		secondLabel,
		id,
		checked,
		isOpen: externalIsOpen,
		onClose: externalOnClose,
		showSwitch = true,
		showRecalculate = true,
	} = props;

	const {
		isOpen: internalIsOpen,
		onOpen,
		onClose: internalOnClose,
	} = useDisclosure();
	const {
		isOpen: isOpenModalNewTicketMedio,
		onOpen: onOpenModalNewTicketMedio,
		onClose: onCloseModalNewTicketMedio,
	} = useDisclosure();

	const isOpen =
		externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
	const onClose = externalOnClose || internalOnClose;

	const [isToggleChecked, setIsToggleChecked] = useState(checked);

	useEffect(() => {
		setIsToggleChecked(checked);
	}, [id, checked]);

	const { form, onChange, setForm } = useForm({
		id: '',
		recalcular: '',
		produto: '',
		codProduto: '',
		ticketMedio: '',
		canalVenda: '',
		familia: '',
	});

	const body = {
		recalcular: false,
		ticket_medio_editado: currencyToNumber(form.ticketMedio),
	};

	const bodyRecalculate = {
		recalcular: true,
		historico_completo: false,
	};

	const { mutate } = useEditAverageTicket(id, false);
	const editTicketMedio = event => {
		event.preventDefault();
		event.stopPropagation();
		mutate(body);
		onClose();
	};

	const { refetch } = useGetTicketMedioById(setForm, id, 'modal');

	const handleIsToggleChecked = () => {
		if (isToggleChecked === true) {
			setIsToggleChecked(!isToggleChecked);
			refetch();
			isToggleChecked && onOpen();
		} else {
			setIsToggleChecked(!isToggleChecked);
			!isToggleChecked && onOpenModalNewTicketMedio();
		}
	};

	const recalculateAverageTicket = () => {
		mutate(bodyRecalculate);
		onCloseModalNewTicketMedio();
	};

	const onClickCancelRecalculate = () => {
		onCloseModalNewTicketMedio();
		setIsToggleChecked(false);
	};

	const initialRef = React.useRef(null);

	useEffect(() => {
		if (isOpen && id) {
			refetch();
		}
	}, [isOpen, id, refetch]);

	return (
		<>
			{showSwitch && (
				<Switch
					colorScheme='red'
					size='sm'
					isChecked={isToggleChecked}
					onChange={handleIsToggleChecked}
				/>
			)}
			<Modal
				initialFocusRef={initialRef}
				isOpen={isOpen}
				onClose={onClose}
				size='xl'
				isCentered
				closeOnOverlayClick={false}
				closeOnEsc={false}
			>
				<ModalOverlay />
				<form onSubmit={editTicketMedio}>
					<ModalContent
						borderRadius={20}
						pt='20px'
					>
						<ModalBody pb={6}>
							<Heading
								color='gray.700'
								mb={2}
								size='md'
							>
								{title}
							</Heading>
							<Text color='gray.500'>{text}</Text>
							<FormControl>
								<FormLabel mt={4}>{firstLabel}</FormLabel>
								<Input
									disabled
									value={form.produto}
								/>
							</FormControl>
							<FormControl mt={4}>
								<FormLabel>{secondLabel} </FormLabel>
								<MoneyField
									maskOptions={''}
									ref={initialRef}
									name={'ticketMedio'}
									value={form.ticketMedio}
									onChange={e => {
										onChange(e);
									}}
									allowNegative={true}
								/>
							</FormControl>
						</ModalBody>

						<ModalFooter>
							<ButtonGroup>
								<ButtonComponent
									type={'ghost'}
									title={
										averageTicketMessages.LABELS
											.CANCEL_BUTTON
									}
									onClick={onClose}
								/>
								<ButtonComponent
									type={'primary'}
									title={
										averageTicketMessages.LABELS.SAVE_BUTTON
									}
									action={'submit'}
								/>
							</ButtonGroup>
						</ModalFooter>
					</ModalContent>
				</form>
			</Modal>
			{showRecalculate && (
				<Modal
					isOpen={isOpenModalNewTicketMedio}
					onClose={onCloseModalNewTicketMedio}
					size='xl'
					isCentered
					closeOnOverlayClick={false}
					closeOnEsc={false}
				>
					<ModalOverlay />
					<ModalContent
						borderRadius={20}
						pt='20px'
					>
						<ModalHeader>
							<Icon
								as={IconRefreshAlert}
								color={'easyRED.300'}
								boxSize={14}
							/>
							<Text
								fontWeight={700}
								color={'easyBLUE.300'}
								fontSize={'2xl'}
							>
								{
									averageTicketMessages.MSG_CONFIRM_RECALCULATE_PRODUCT_CHANNEL
								}
							</Text>
						</ModalHeader>
						<ModalBody>
							<Text
								color='gray.500'
								mb={4}
							>
								{
									averageTicketMessages.MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_1
								}
							</Text>
							<Text
								color='gray.500'
								mb={4}
							>
								<strong>
									{
										averageTicketMessages.MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_2
									}
								</strong>{' '}
								{
									averageTicketMessages.MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_3
								}
							</Text>
							<Text color='gray.500'>
								{
									averageTicketMessages.MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_4
								}
							</Text>
						</ModalBody>
						<ModalFooter>
							<ButtonGroup>
								<ButtonComponent
									type={'ghost'}
									title={
										averageTicketMessages.LABELS
											.CANCEL_BUTTON
									}
									onClick={onClickCancelRecalculate}
								/>
								<ButtonComponent
									type={'secondary'}
									title={
										averageTicketMessages.SCREEN_TITLES
											.RECALCULATE_AVERAGE_TICKET
									}
									onClick={recalculateAverageTicket}
								/>
							</ButtonGroup>
						</ModalFooter>
					</ModalContent>
				</Modal>
			)}
		</>
	);
}
